var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 348 557.27",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4c4c4c",
  d: "M305.86 124.9h-93.64A42.4 42.4 0 0 0 196 106.75L240 5.19 230.66 0l-44 102.52a42.4 42.4 0 0 0-23.45-.54L127.65.03 118 3.43l35.66 102.38a42.32 42.32 0 0 0-17.88 19H42.14A42.15 42.15 0 0 0 0 167.05v162.56a42.14 42.14 0 0 0 42.13 42.2h8.38L21.82 557.26h6l66.49-185.53h159.38l66.47 185.53h6l-28.67-185.45h8.37A42.14 42.14 0 0 0 348 329.62V167.06a42.15 42.15 0 0 0-42.14-42.16M73.45 340.45a42.14 42.14 0 0 1-42.16-42.12v-98.77a42.14 42.14 0 0 1 42.14-42.14h164.64a42.14 42.14 0 0 1 42.11 42.14v98.75A42.14 42.14 0 0 1 238 340.45zm235.1-58.28a13.85 13.85 0 1 1 13.85-13.84 13.85 13.85 0 0 1-13.85 13.84m0-38.89a13.85 13.85 0 1 1 13.85-13.85 13.85 13.85 0 0 1-13.85 13.85m0-38.23a13.85 13.85 0 1 1 13.85-13.84 13.84 13.84 0 0 1-13.85 13.83Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 248.89,
  height: 183.03,
  x: 31.29,
  y: 157.43,
  fill: "#898989",
  rx: 42.4,
  ry: 42.4
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg404);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/404.7a7c3992052e6c3306c070643118c448.svg";